import { store } from "utils/store";

const userEmail = store.getState().auth.email;

export const templateOptions = [
  {
    label: "All Templates",
    value: "all",
  },
  {
    label: "My Templates",
    value: "my",
  },
  {
    label: "Predesign Templates",
    value: "system",
  },
];

export const templateMenu = ({
  isPublicTemplate,
  selectedTemplate,
}: {
  isPublicTemplate: boolean;
  selectedTemplate: any;
}) => {
  const visibility = isPublicTemplate ? "Private" : "Public";
  let menuItems = [
    {
      label: "Preview",
      value: "preview",
    },

    {
      label: "Duplicate",
      value: "duplicate",
    },
  ];

  if (selectedTemplate?.category === "System") {
    menuItems = [
      {
        label: "Duplicate",
        value: "duplicate",
      },
      {
        label: "Preview",
        value: "preview",
      },
    ];
  } else if (selectedTemplate?.owner?.includes(userEmail)) {
    menuItems.push(
      {
        label: "Edit",
        value: "edit",
      },
      {
        label: "Rename",
        value: "rename",
      },
      {
        label: `Mark it ${visibility}`,
        value: "visibility",
      },
      {
        label: "Delete",
        value: "delete",
      }
    );
  }

  return menuItems;
};
